import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import * as XLSX from 'xlsx';
import { GatewayService } from 'src/app/gateway.service';
import { switchMap, debounceTime, tap, finalize, skip } from 'rxjs/operators';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, PageEvent } from '@angular/material';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { ComponentTabController } from 'src/app/tab-controller';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { UploadServiceService } from 'src/app/services/upload-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { TipoServicioService } from '../tipo-servicio.service';

@Component({
  selector: 'app-schedule-citas',
  templateUrl: './schedule-citas.component.html',
  styleUrls: ['./schedule-citas.component.scss']
})
export class ScheduleCitasComponent implements OnInit {
  sanitizeurl: any = null;
  clienteactivo: any = {};

  // Llave secreta
  private secretKey: string = 'your-256-bit-secret';

  constructor(
    public _sanitizer: DomSanitizer,
    public gateway: GatewayService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    public localSave: LocalSaveService,
    public tabController: ComponentTabController,
    private spinner: NgxSpinnerService,
    private uploadService: UploadServiceService,
    private _tipoServicio: TipoServicioService
  ) { }

  ngOnInit() {
    this.loadIframe();
    this._tipoServicio.notifyObservable$.pipe(
      skip(1)
    ).subscribe(() => {
      this.loadIframe();
    });
  }

  loadIframe() {

    // const payload = {
    //   id_contrata: 1, // idcontrata
    //   id_cliente: 1,
    //   id_usuario: 1, // idagente
    //   id_caso: '',
    //   direccion: 'Calle 123',
    //   cod_cuenta: '123456',
    // };

    this.clienteactivo = this.localSave.get('inittab');

    // console.log('-------usupgv ------------')
    // console.log(this.localSave.get('usuarioPGV'))

    const tipoActual = this._tipoServicio.getValorActual();
    let payload = {};
    if (this.localSave.get('usuarioPGV').idrol == 16) {
      payload = {
        id_admin: tipoActual.IDU,
        id_contrata: null,
        id_area: tipoActual.IDAREA
      };
    }
    else {
      payload = {
        id_admin: tipoActual.IDPADRE,
        id_contrata: tipoActual.IDU,
        id_area: tipoActual.IDAREA,
        technology: this.localSave.get('usuarioPGV').OBJ.technology ? this.localSave.get('usuarioPGV').OBJ.technology : '',
      };
    }

    this.gateway.get('gettoken', { payload })
      .then((result: any) => {
        // Generar el token
        // const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZF9hZG1pbiI6MSwiaWRfY29udHJhdGEiOjF9.iQP-V2oGFQp3V72y3paZjRTzPGW7bvixm3x8hbC4mmQ'

        const token = result.token;
        if (this.localSave.get('usuarioPGV').idrol == 16) {
          this.sanitizeurl = this._sanitizer.bypassSecurityTrustResourceUrl(`${environment.baseUrlPGViFrame}/list?token=${token}`);
        }else{
          this.sanitizeurl = this._sanitizer.bypassSecurityTrustResourceUrl(`${environment.baseUrlPGViFrame}/citas?token=${token}`);
        }
        this.spinner.hide();
      }).catch((error: any) => {
      });
  }
}
